import { useGet } from '../../HttpClient';
import { ClosureReasonModel } from '@app/models';
import { referenceDataBaseUrl } from '../BaseUrls';
import { useQueryWithErrorHandling } from '../../../hooks/UseQueryWithErrorHandling';
import { useQueryClient } from '@tanstack/react-query';

const pillarCode = "tms";
 
export function useClosureReasons() {
  const get = useGet(true, pillarCode);
  const getClosureReasons = (): Promise<ClosureReasonModel[]> => get(`${referenceDataBaseUrl}/closure-reasons`);
  return useQueryWithErrorHandling({
    queryKey: ['closure-reasons'],
    queryFn: async () => await getClosureReasons(),
  });
}

export function useRefreshClosureReasons() {
  const queryClient = useQueryClient();

  return () => queryClient.invalidateQueries({ queryKey: ['closure-reasons'] });
}
